import React, { memo, useMemo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function ButtonSelector({
  id,
  label,
  onClick: handleClick,
  sliceName,
  keyName,
  disabled = false,
  isActive: isActiveFromProp,
  tooltipMessage = undefined,
}) {
  const isActiveFromStore = useThreeDStudioStore(
    (state) => state?.[sliceName]?.[keyName] === id
  )
  const mergedIsActive = useMemo(() => {
    if (isActiveFromProp !== undefined && isActiveFromProp !== null) {
      return isActiveFromProp
    }

    return isActiveFromStore
  }, [isActiveFromProp, isActiveFromStore])

  // Always route through DesktopOnlyTooltip, even without a message. On desktop it
  // then wraps every button in the same container/trigger spans, so a button's flex
  // box stays the same type when it gains a disabled-state tooltip - otherwise the
  // bare <button> (enabled) and wrapped <span> (disabled) round to different widths
  // and the whole button-group row jumped on toggle. On mobile it returns the bare
  // child either way, so nothing changes there.
  return (
    <DesktopOnlyTooltip
      content={tooltipMessage}
      id={`button-selector-tooltip-${id}`}
      containerClass="button-group-selector__tooltip"
      className="button-group-selector__tooltip-trigger"
    >
      <Button
        type="secondary"
        size="tiny"
        onClick={handleClick}
        isActive={mergedIsActive}
        customClass="button-group-selector__button"
        disabled={disabled}
      >
        {label}
      </Button>
    </DesktopOnlyTooltip>
  )
}

ButtonSelector.propTypes = {
  id: string.isRequired,
  keyName: string.isRequired,
  label: string.isRequired,
  onClick: func.isRequired,
  sliceName: string.isRequired,
  disabled: bool,
  isActive: bool,
  tooltipMessage: string,
}

export default memo(ButtonSelector)
